import React from 'react'

const PlanData = () => {
    return (
        <div>PlanData</div>
    )
}

export default PlanData